'use strict';

function DecimalFilter($filter) {
  return (input, decimalSize) => {
    if(!input || Number.isNaN(input)) { return input; }
    const factor = Math.pow(10, decimalSize);
    const roundedNum = Math.round(input * factor) / factor;
    return $filter('number')(roundedNum);
  }
}

export default angular.module('leptonApp.DecimalFilter', [])
  .filter('decimalFilter', ['$filter', DecimalFilter])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/filter/decimal-filter/decimal.filter.js